<template>
  <color-picker
    :label="$t('edit.sidebar.text_color')"
    :id="getId()"
    :value="value()"
    :change="onColorChange"
    :move="onMove"
  ></color-picker>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ColorPicker from '../../../../general/ColorPicker.vue';

const defaultValue = '#FFFFFF';

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    ColorPicker,
  },
  methods: {
    getId() {
      return `color-${this.item}`;
    },
    value() {
      const style = this.stepStyle(this.item);

      if (!style || !style.color) {
        return defaultValue;
      }

      return style.color.replace('px', '');
    },
    onColorChange(color) {
      if (this.general) {
        return this.quizUpdateStyle({ item: this.item, rule: 'color', value: color });
      }

      return this.stepUpdateStyle({ item: this.item, rule: 'color', value: color });
    },
    onMove(color) {
      if (this.general) {
        return this.quizPreviewStyleChange({ item: this.item, rule: 'color', value: color });
      }

      return this.stepPreviewStyleChange({ item: this.item, rule: 'color', value: color });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>




/** WEBPACK FOOTER **
 ** Color.vue?4603ad1a
 **/